import * as React from 'react';
import bodymovin from 'bodymovin';

type Props = {
  style: object;
  animationOptions: bodymovin.AnimationOptions;
  onAnimationLoaded: (animation: any) => void;
};

export default class extends React.Component<Props> {
  static displayName = 'Animation';

  container;
  animation;

  componentWillReceiveProps({ onAnimationLoaded, animationOptions }) {
    if (this.props.animationOptions !== animationOptions) {
      this.animation && this.animation.destroy();
      this.animation = bodymovin.loadAnimation({
        ...animationOptions,
        container: this.container,
      });

      onAnimationLoaded && onAnimationLoaded(this.animation);
    }
  }

  componentDidMount() {
    const { onAnimationLoaded, animationOptions } = this.props;
    this.animation = bodymovin.loadAnimation({
      ...animationOptions,
      container: this.container,
    });

    onAnimationLoaded && onAnimationLoaded(this.animation);
  }

  componentWillUnmount() {
    this.animation && this.animation.destroy();
    this.animation = null;
  }

  render() {
    const { onAnimationLoaded, animationOptions, style, ...props } = this.props;
    return <div {...props} style={style} ref={(container) => (this.container = container)} />;
  }
}



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/LottieAnimationViewer.tsx